import { DataListHeader, NoResults, PaginationBar } from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { searchCallback } from '../recoil/callbacks/callbacks'
import { resultsState, searchState } from '../recoil/state/page'
import { OrderBy } from './OrderBy'
import Row from './Row'

const Results = () => {
  const intl = useIntl()
  const { items, totalItems } = useRecoilValue(resultsState)
  const [{ pageNumber, pageSize }, setSearchState] = useRecoilState(searchState)
  const search = useRecoilCallback(searchCallback, [])
  const { idSource } = useParams()

  const heads = [
    {
      label: '',
      span: 9,
      sortable: false
    },
    {
      label: <OrderBy />,
      span: 3,
      sortable: false,
      align: 'right'
    }
  ]

  const handleChangePage = (pageNumber) => {
    setSearchState((prev) => ({
      ...prev,
      pageNumber
    }))
    search(idSource, false)
  }

  const handleChangePageSize = (pageSize) => {
    setSearchState((prev) => ({
      ...prev,
      pageNumber: 1,
      pageSize
    }))
    search(idSource, false)
  }

  return (
    <>
      {items.length > 0 && (
        <>
          <DataListHeader heads={heads} />
          {items.map((item, key) => (
            <Row item={item} key={key} />
          ))}
          <PaginationBar
            pageSize={pageSize}
            pageNumber={pageNumber}
            totalItems={totalItems}
            handleChangePage={handleChangePage}
            handleChangePageSize={handleChangePageSize}
            strings={{
              of: intl.formatMessage({ id: 'Load.Pager.Of' }),
              label: intl.formatMessage({ id: 'Load.Pager.Items' })
            }}
          />
        </>
      )}
      {items.length === 0 && (
        <NoResults
          text={
            intl.formatMessage({
              id: 'Load.ContentsSourcesViewContents.NoSearchResultTitle'
            }) +
            ' ' +
            intl.formatMessage({
              id: 'Load.ContentsSourcesViewContents.NoSearchResultDescription'
            })
          }
        />
      )}
    </>
  )
}

export default Results
